; (function ($) {

    if (!$("body").hasClass("threetwotwosix_alt_template-hero")) return;

	console.log('slideshow for alt product template: hero')
	
	let currentSlide = 0;
	let slideMax = $('ul.hero-slideshow li').length;

	let killSlideshow = function() {
		clearInterval(slideshowInterval);		
	}

	let prevSlide = function () {
		console.log('prevSlide')
		currentSlide--;
		if (currentSlide < 0) currentSlide = slideMax - 1;
		changeSlide()
	}

	let nextSlide = function () {
		console.log('nextSlide')
		currentSlide++;
		if (currentSlide >= slideMax) currentSlide = 0;
		changeSlide()
	}
	
	let changeSlide = function () {
		console.log('changeSlide', currentSlide)
		let $old = $('ul.hero-slideshow li.active, ul.hero-slideshow li.transitioning');
		let $new = $('ul.hero-slideshow li').eq(currentSlide)
		if ($new.hasClass('active') || $new.hasClass('transitioning')) {
			return; // already showing or transitioning to this one
		}
		$new.addClass('transitioning');
		setTimeout(function() {
			$old.removeClass('active')
			$new.removeClass('transitioning').addClass('active')
		}, 300)
	}

	let slideshowInterval = setInterval(nextSlide, 5000)

	$('ul.hero-slideshow a.arrow-prev').on('click', function() {
		prevSlide();
		killSlideshow();
	})
	$('ul.hero-slideshow a.arrow-next').on('click', function() {
		nextSlide();
		killSlideshow();
	})

	$('.thumbnails a').on('click', function (e) {
		e.preventDefault();	
		currentSlide = $(this).index();
		changeSlide();
		killSlideshow();
	})

})(jQuery);